import React, { useState } from 'react';
import { FormattedMessage } from '../../../util/reactIntl';
import { OutsideClickHandler } from '../../../components';
import css from './MobileCategoryFilter.module.css';

const DownArrowIcon = () => (
  <svg
    width="14"
    height="8"
    viewBox="0 0 14 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 7.35723C6.91803 7.35826 6.83676 7.34164 6.76141 7.30842C6.68606 7.27521 6.61831 7.22614 6.5625 7.16438L0.9375 1.37866C0.6875 1.12152 0.6875 0.722949 0.9375 0.465806C1.1875 0.208664 1.575 0.208664 1.825 0.465806L7.0125 5.80152L12.1875 0.478664C12.4375 0.221521 12.825 0.221521 13.075 0.478664C13.325 0.735806 13.325 1.13438 13.075 1.39152L7.45 7.17724C7.325 7.30581 7.1625 7.37009 7.0125 7.37009L7 7.35723Z"
      fill="#2F0F48"
    />
  </svg>
);

const MobileCategoryFilter = props => {
  const {
    spaceGroups,
    handleSearch,
    setSelectedCategory,
    selectedCategory,
    setKeyword,
    setSortingOption,
  } = props;

  const [isOpen, setIsOpen] = useState(false);
  const { records } = spaceGroups || {};

  const onSelectCategory = item => {
    handleSearch('space_group', item);
    setSelectedCategory(item);
    setIsOpen(false);
  };

  const handleClearAll = () => {
    setSelectedCategory('');
    setKeyword('');
    setSortingOption('');
    handleSearch();
    setIsOpen(false);
  };

  const selectedCategoryName = records?.find(
    item => String(item.id) === String(selectedCategory) || item.slug === selectedCategory
  )?.name;

  return (
    <div className={css.categoryWrapper}>
      <OutsideClickHandler onOutsideClick={() => isOpen && setIsOpen(false)}>
        <div
          onClick={() => setIsOpen(!isOpen)}
          className={`${css.categoryFilter} ${isOpen ? css.open : ''}`}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
            <path d="M8.46286 4.70156C8.21347 4.70156 7.9743 4.80063 7.79795 4.97698C7.62161 5.15332 7.52254 5.3925 7.52254 5.64189C7.52254 5.89128 7.62161 6.13045 7.79795 6.3068C7.9743 6.48314 8.21347 6.58221 8.46286 6.58221C8.71225 6.58221 8.95143 6.48314 9.12777 6.3068C9.30412 6.13045 9.40319 5.89128 9.40319 5.64189C9.40319 5.3925 9.30412 5.15332 9.12777 4.97698C8.95143 4.80063 8.71225 4.70156 8.46286 4.70156ZM5.80174 4.70156C5.99601 4.15097 6.35629 3.67419 6.8329 3.33695C7.30951 2.99971 7.879 2.8186 8.46286 2.8186C9.04672 2.8186 9.61621 2.99971 10.0928 3.33695C10.5694 3.67419 10.9297 4.15097 11.124 4.70156H17.8661C18.1155 4.70156 18.3547 4.80063 18.531 4.97698C18.7074 5.15332 18.8065 5.3925 18.8065 5.64189C18.8065 5.89128 18.7074 6.13045 18.531 6.3068C18.3547 6.48314 18.1155 6.58221 17.8661 6.58221H11.124C10.9297 7.13281 10.5694 7.60958 10.0928 7.94683C9.61621 8.28407 9.04672 8.46517 8.46286 8.46517C7.879 8.46517 7.30951 8.28407 6.8329 7.94683C6.35629 7.60958 5.99601 7.13281 5.80174 6.58221H4.70156C4.45217 6.58221 4.21299 6.48314 4.03665 6.3068C3.8603 6.13045 3.76123 5.89128 3.76123 5.64189C3.76123 5.3925 3.8603 5.15332 4.03665 4.97698C4.21299 4.80063 4.45217 4.70156 4.70156 4.70156H5.80174ZM14.1048 10.3435C13.8554 10.3435 13.6163 10.4426 13.4399 10.6189C13.2636 10.7953 13.1645 11.0345 13.1645 11.2838C13.1645 11.5332 13.2636 11.7724 13.4399 11.9488C13.6163 12.1251 13.8554 12.2242 14.1048 12.2242C14.3542 12.2242 14.5934 12.1251 14.7697 11.9488C14.9461 11.7724 15.0451 11.5332 15.0451 11.2838C15.0451 11.0345 14.9461 10.7953 14.7697 10.6189C14.5934 10.4426 14.3542 10.3435 14.1048 10.3435ZM11.4437 10.3435C11.638 9.79293 11.9982 9.31615 12.4749 8.97891C12.9515 8.64166 13.521 8.46056 14.1048 8.46056C14.6887 8.46056 15.2582 8.64166 15.7348 8.97891C16.2114 9.31615 16.5717 9.79293 16.7659 10.3435H17.8661C18.1155 10.3435 18.3547 10.4426 18.531 10.6189C18.7074 10.7953 18.8065 11.0345 18.8065 11.2838C18.8065 11.5332 18.7074 11.7724 18.531 11.9488C18.3547 12.1251 18.1155 12.2242 17.8661 12.2242H16.7659C16.5717 12.7748 16.2114 13.2515 15.7348 13.5888C15.2582 13.926 14.6887 14.1071 14.1048 14.1071C13.521 14.1071 12.9515 13.926 12.4749 13.5888C11.9982 13.2515 11.638 12.7748 11.4437 12.2242H4.70156C4.45217 12.2242 4.21299 12.1251 4.03665 11.9488C3.8603 11.7724 3.76123 11.5332 3.76123 11.2838C3.76123 11.0345 3.8603 10.7953 4.03665 10.6189C4.21299 10.4426 4.45217 10.3435 4.70156 10.3435H11.4437ZM8.46286 15.9855C8.21347 15.9855 7.9743 16.0845 7.79795 16.2609C7.62161 16.4372 7.52254 16.6764 7.52254 16.9258C7.52254 17.1752 7.62161 17.4144 7.79795 17.5907C7.9743 17.7671 8.21347 17.8661 8.46286 17.8661C8.71225 17.8661 8.95143 17.7671 9.12777 17.5907C9.30412 17.4144 9.40319 17.1752 9.40319 16.9258C9.40319 16.6764 9.30412 16.4372 9.12777 16.2609C8.95143 16.0845 8.71225 15.9855 8.46286 15.9855ZM5.80174 15.9855C5.99601 15.4349 6.35629 14.9581 6.8329 14.6209C7.30951 14.2836 7.879 14.1025 8.46286 14.1025C9.04672 14.1025 9.61621 14.2836 10.0928 14.6209C10.5694 14.9581 10.9297 15.4349 11.124 15.9855H17.8661C18.1155 15.9855 18.3547 16.0845 18.531 16.2609C18.7074 16.4372 18.8065 16.6764 18.8065 16.9258C18.8065 17.1752 18.7074 17.4144 18.531 17.5907C18.3547 17.7671 18.1155 17.8661 17.8661 17.8661H11.124C10.9297 18.4167 10.5694 18.8935 10.0928 19.2307C9.61621 19.568 9.04672 19.7491 8.46286 19.7491C7.879 19.7491 7.30951 19.568 6.8329 19.2307C6.35629 18.8935 5.99601 18.4167 5.80174 17.8661H4.70156C4.45217 17.8661 4.21299 17.7671 4.03665 17.5907C3.8603 17.4144 3.76123 17.1752 3.76123 16.9258C3.76123 16.6764 3.8603 16.4372 4.03665 16.2609C4.21299 16.0845 4.45217 15.9855 4.70156 15.9855H5.80174Z" fill="black" />
          </svg>
          Filters ({records?.filter(item => item.id !== 615609)?.length || 0})
        </div>
        {isOpen && (
          <div className={css.dropdownMenu}>
            <ul>
              {Array.isArray(records)
                ? records
                  ?.filter(item => item.id !== 615609)
                  ?.map(item => (
                    <li
                      key={item.id}
                      onClick={() => onSelectCategory(String(item.id))}
                      className={String(selectedCategory) === String(item.id) ? css.selectedItem : ''}
                    >
                      {item.name}
                    </li>
                  ))
                : null}
              {selectedCategory && (
                <>
                  <li className={css.spacer}></li>
                  <li onClick={handleClearAll} className={css.clearFilter}>
                    <FormattedMessage id="CircleFeedPage.clearFilter" />
                  </li>
                </>
              )}
            </ul>
          </div>
        )}
      </OutsideClickHandler>
    </div>
  );
};

export default MobileCategoryFilter;
